import { Card, SquareNewWindowIcon, Typography } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import Button from "components/Button";

import styles from "./GettingStarted.module.css";
import {
  GettingStartedName,
  getGettingStartedCopy,
} from "./GettingStartedCopy";

interface GettingStartedProps {
  card: GettingStartedName;
  hasAPIKeyViewPermission: boolean;
}

const GettingStarted: React.FC<GettingStartedProps> = ({
  card,
  hasAPIKeyViewPermission,
}) => {
  const { title, description, icon, primaryCta, secondaryCta } =
    getGettingStartedCopy(card, hasAPIKeyViewPermission);

  return (
    <Card
      className={classNames(styles.card, {
        [styles.gettingStartedCard]: card === "gettingStarted",
        [styles.addCompanyCard]: card === "addCompany",
        [styles.apiAccessCard]: card === "apiAccess",
      })}
      data-testid="getting-started-card"
      size="small"
    >
      <div className={styles.header}>
        <div
          className={classNames(styles.icon, {
            [styles.apiAccessIcon]: card === "apiAccess",
            [styles.vectorIcon]: !hasAPIKeyViewPermission,
          })}
        >
          {icon}
        </div>
        <Typography
          as="h3"
          variant="heading_sm"
          className={classNames(styles.title, {
            [styles.apiAccessTitle]: card === "apiAccess",
          })}
        >
          {title}
        </Typography>
      </div>
      <Typography
        as="p"
        variant="body_sm"
        className={classNames(styles.description, {
          [styles.apiAccessDescription]: card === "apiAccess",
        })}
      >
        {description}
      </Typography>
      <div className={styles.ctaWrapper}>
        <Button
          variant="secondary"
          labelColor="interface"
          color={card === "apiAccess" ? "action" : "white"}
          size="small"
          data-testid="primary-cta-button"
          href={primaryCta.href ?? undefined}
          to={primaryCta.to ?? undefined}
          buttonName={primaryCta.buttonName}
          target={primaryCta.opensInNewTab ? "_blank" : undefined}
        >
          <span>{primaryCta.text}</span>
          {primaryCta.opensInNewTab && (
            <SquareNewWindowIcon className={styles.ctaMargin} />
          )}
        </Button>
        {secondaryCta && (
          <Button
            variant="tertiary"
            color="white"
            size="small"
            data-testid="secondary-cta-button"
            href={secondaryCta.href ?? undefined}
            to={secondaryCta.to ?? undefined}
            buttonName={secondaryCta.buttonName ?? ""}
            className={styles.ctaMargin}
            target={secondaryCta.opensInNewTab ? "_blank" : undefined}
          >
            <span>{secondaryCta.text}</span>
            {secondaryCta.opensInNewTab && (
              <SquareNewWindowIcon className={styles.ctaMargin} />
            )}
          </Button>
        )}
      </div>
    </Card>
  );
};

export default GettingStarted;
